import { render, staticRenderFns } from "./CustomerStatisticDetails.vue?vue&type=template&id=6b9a5e4f&scoped=true"
import script from "./CustomerStatisticDetails.vue?vue&type=script&lang=js"
export * from "./CustomerStatisticDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerStatisticDetails.vue?vue&type=style&index=0&id=6b9a5e4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a5e4f",
  null
  
)

export default component.exports